import React from 'react'
import Button from '.'
import styles from './styles.module.css'

const ButtonOutline = props => {
  return <Button className={`${styles.button} ${styles.buttonOutline}`} {...props} />
}

export default ButtonOutline
